const cfbInitialState = {
	schedules: [],
	teams: [],
	healthScores: [],
	matchup: { match: [], homePlayers: [], awayPlayers: [], homeRosterPlayers: [], awayRosterPlayers: [] },
	player: null,
	playerNews: [],
	teamNews: [],
	isLoading: false,
	isLoaded: false,
	error: null
};

export default function cfbReducer(state = cfbInitialState, action) {
	switch (action.type) {
		case 'GET_CFB_SCHEDULES':
		case 'GET_CFB_TEAMS':
		case 'GET_CFB_HEALTH_SCORES':
		case 'GET_CFB_MATCHUP':
		case 'GET_CFB_PLAYER':
			return { ...state, isLoading: true, error: null };

		case 'GET_CFB_SCHEDULES_SUCCESS':
			return { ...state, isLoading: false, isLoaded: true, schedules: action.payload };

		case 'GET_CFB_TEAMS_SUCCESS':
			return { ...state, isLoading: false, isLoaded: true, teams: action.payload };

		case 'GET_CFB_HEALTH_SCORES_SUCCESS':
			return { ...state, isLoading: false, isLoaded: true, healthScores: action.payload };

		case 'GET_CFB_MATCHUP_SUCCESS':
			return { ...state, isLoading: false, isLoaded: true, matchup: action.payload };

		case 'GET_CFB_PLAYER_SUCCESS':
			return { ...state, isLoading: false, player: action.payload };

		case 'GET_CFB_PLAYER_NEWS_SUCCESS':
			return {
				...state,
				playerNews: Array.isArray(action.payload?.playerNews) ? action.payload.playerNews : [],
				teamNews: Array.isArray(action.payload?.teamNews) ? action.payload.teamNews : [],
			};

		case 'GET_CFB_SCHEDULES_ERROR':
		case 'GET_CFB_TEAMS_ERROR':
		case 'GET_CFB_HEALTH_SCORES_ERROR':
		case 'GET_CFB_MATCHUP_ERROR':
		case 'GET_CFB_PLAYER_ERROR':
		case 'GET_CFB_PLAYER_NEWS_ERROR':
			return { ...state, isLoading: false, error: action.payload?.message || 'An error occurred' };

		default:
			return state;
	}
}
